var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { Accordion, Button, Checkbox, Dimmer, Dropdown, Form, Grid, Header, Icon, Input, List, Loader, Message, Modal, Segment, Table } from "semantic-ui-react";
import AllErrorDisplay from "../AllErrorDisplay";
import { AppPaths } from '../AppConfig';
import { API_SVC_BASE_URL, ORIGIN } from "../Config";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { Help } from "../Help";
import { automatedIfKitToFormState } from "../kit/automated-gold-if/AutomatedIfToFormState";
import { defaultAutomatedIfFormState, serializeAutomatedIfKit } from "../kit/automated-gold-if/EditKitForm";
import AdminEditKitForm, { defaultAdminAutomatedProFormState, } from "../kit/automated-pro/AdminEditKitForm";
import { RelevantCatalogType, } from "../kit/automated-pro/RnaCatalog";
import { rnaCishKitToAdminFormState } from "../kit/automated-pro/RnaCishKitToAdminFormState";
import { MetaCatalogLoader } from "../kit/Catalog";
import KitIndexHeader from "../kit/KitIndexHeader";
import { defaultManualGoldIfFormState, serializeManualGoldIfKit } from "../kit/manual-gold-if/EditKitForm";
import { encoderKitToFormState } from "../kit/manual-gold-if/ManualGoldIfKitToFormState";
import ManualProAdminKitForm, { defaultManualProAdminFormState } from "../kit/manual-pro/ManualProAdminKitForm";
import { manualProKitToAdminFormState } from "../kit/manual-pro/ManualProKitToAdminFormState";
import EditKitForm, { defaultFormState, formatMonetaryDecimal } from "../kit/rna-fish/EditKitForm";
import KitDisplay, { abbreviateRnaWithModal, numOfBindingSitesDisplay } from "../kit/rna-fish/KitDisplay";
import { AutomatedGoldIfKit, AutomatedGoldIfPricedKit, AutomatedProKit, AutomatedProPricedKit, ManualGoldIfKit, ManualGoldIfPricedKit, ManualProKit, ManualProPrice, PricedManualProKit, RnaFishKit, RnaFishKitPrice, RnaFishPricedKit, SecondaryIfKit, SecondaryIfPricedKit, SimpleCatalogVariantProbeSet, SimpleLibraryOrganismCustomTargetProbeSet, SimpleOtherOrganismCustomTargetProbeSet } from "../kit/rna-fish/KitModel";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { rnaFishKitToFormState } from "../kit/rna-fish/RnaFishKitToFormState";
import { defaultSecondaryIfFormState, serializeSecondaryIfKit } from "../kit/secondary-if/EditKitForm";
import { secondaryIfKitToFormState } from "../kit/secondary-if/SecondaryIfKitToFormState";
import KitDeserializer, { Channel } from "../KitDeserializer";
import { CatalogMode, getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { PizzaTracker } from "../UserOrderPage";
import AddLineItemModal from "./AddLineItemModal";
import AddCommentModal from "./AddOrderComment";
import AddOrderPoComment from "./AddOrderPoComment";
import AddShipmentModal from "./AddOrderShipment";
import AddShipmentTrackingModal from "./AddOrderShipmentTracking";
import { displayLocalTimestamp } from "./AllOrdersPage";
import ArchiveOrderCommentModal from "./ArchiveOrderCommentModal";
import AssignKitToProbeLotModal from "./AssignKitToProbeLotModal";
import ProbeDesignCommentModal from "./ProbeDesignCommentModal";
import CancelShipmentModal from "./CancelShipmentModal";
import ChangeAutomatedActionStatus from "./ChangeAutomatedActionStatus";
import ChangePoApprovalType from "./ChangePoApprovalType";
import CreateEstimateModal from "./CreateEstimateModal";
import CreateInvoiceModal from "./CreateInvoiceModal";
import CreateShipmentModal from "./CreateShipmentModal";
import { DeleteKitConfirmation } from "./DeleteKitConfirmation";
import DeleteLineItemModal from "./DeleteLineItemModal";
import EditAddressesModal from "./EditOrderAddresses";
import EditOrderBillingInfoModal from "./EditOrderBillingInfoModal";
import EditOrderCommentModal from "./EditOrderCommentModal";
import { determineKitType, InternalUserEditKitModal, KitType } from "./EditOrderKit";
import StatusEditModal from "./EditOrderStatuses";
import { EmailCurrentVersionModal } from "./EmailCurrentVersionModal";
import { LabelsModal } from "./LabelsModal";
import SendPoReminderModal from "./SendPoReminderModal";
import SendTrackingNumberModal from "./SendTrackingNumberModal";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UploadCommentAttachmentsModal from "./UploadCommentAttachment";
import UploadShipmentPhotoModal from "./UploadShipmentPhotos";
import AddToCatalogContainerModal from "./VariantDesignerModal";
import ViewShipmentPhotosModal from "./ViewShipmentPhotos";
var SingleOrderPage = /** @class */ (function (_super) {
    __extends(SingleOrderPage, _super);
    function SingleOrderPage(props) {
        var _this = _super.call(this, props) || this;
        _this.openKitModal = function (modalType) {
            _this.setState({ activeKitModalType: modalType });
        };
        _this.closeKitModal = function () {
            _this.setState({ activeKitModalType: null, selectedKitOption: '' });
            _this.loadOrder();
        };
        _this.handleKitModalChange = function (_, data) {
            if (data.value) {
                _this.setState({ selectedKitOption: data.value });
                _this.openKitModal(data.value);
            }
        };
        _this.getKitOptions = function () { return [
            { key: 'legacy-rna-fish', text: 'RNA-FISH (v3.0)', value: 'legacy-rna-fish' },
            { key: 'rna-fish', text: 'Gold RNA-FISH', value: 'rna-fish' },
            { key: 'manual-gold-if', text: 'Gold IF (Manual)', value: 'manual-gold-if' },
            { key: 'automated-gold-if', text: 'Gold IF (Automated)', value: 'automated-gold-if' },
            { key: 'manual-pro', text: 'Pro RNA-ISH (Manual)', value: 'manual-pro' },
            { key: 'rna-cish', text: 'Pro RNA-ISH (Automated)', value: 'rna-cish' },
            { key: 'ihc2', text: 'Gold 2ºIF', value: 'ihc2' },
            { key: 'legacy-ihc2', text: '2ºIF', value: 'legacy-ihc2' },
        ]; };
        _this.addKitModalRenderer = function (kitType) {
            return function (catalog) {
                return React.createElement(InternalUserEditKitModal, { catalog: catalog, endpoint: "/admin/orders/id/" + encodeURIComponent(_this.state.orderResponse.order.id) + "/items", kitType: kitType, negativeControlProbe: true, initialRnaFishFormState: defaultFormState(catalog.rnaCatalog, kitType === KitType.LegacyRnaFish), initialSecondaryIfFormState: defaultSecondaryIfFormState(catalog.secondaryIfCatalog, kitType === KitType.LegacyIhc2), initialRnaCishFormState: defaultAdminAutomatedProFormState(catalog.rnaCatalog), initialManualProFormState: defaultManualProAdminFormState(catalog.rnaCatalog), initialEncoderFormState: defaultManualGoldIfFormState(catalog.secondaryIfCatalog), initialAutomatedIfFormState: defaultAutomatedIfFormState(catalog.secondaryIfCatalog), loadPricesOnMount: false, orderId: _this.state.orderResponse.order.id });
            };
        };
        // ordering lints are too dumb to realize this has to come after the helper it uses, because JS...
        // tslint:disable-next-line:member-ordering
        _this.renderAddLegacyRnaFishKitModal = _this.addKitModalRenderer(KitType.LegacyRnaFish);
        // tslint:disable-next-line:member-ordering
        _this.renderAddRnaFishKitModal = _this.addKitModalRenderer(KitType.NewRnaFish);
        // tslint:disable-next-line:member-ordering
        _this.renderAddSecondaryIfKitModal = _this.addKitModalRenderer(KitType.NewIhc2);
        // tslint:disable-next-line:member-ordering
        _this.renderAddLegacySecondaryIfKitModal = _this.addKitModalRenderer(KitType.LegacyIhc2);
        // tslint:disable-next-line:member-ordering
        _this.renderAddManualGoldIfKitModal = _this.addKitModalRenderer(KitType.Encoder);
        // tslint:disable-next-line:member-ordering
        _this.renderAddRnaCishKitModal = _this.addKitModalRenderer(KitType.RnaCish);
        // tslint:disable-next-line:member-ordering
        _this.renderAddManualProKitModal = _this.addKitModalRenderer(KitType.ManualPro);
        // tslint:disable-next-line:member-ordering
        _this.renderAddAutomatedGoldIfKitModal = _this.addKitModalRenderer(KitType.AutomatedGoldIf);
        _this.renderEditBillingContactInfoModal = function (order) {
            var renderModal = function (props) {
                return React.createElement(EditOrderBillingInfoModal, __assign({ orderId: order.id, initialBillingEmail: order.billingEmail }, props));
            };
            return React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit billing contact info', labelPosition: 'left' }), onClose: _this.loadOrder },
                React.createElement(Modal.Header, null, "Edit billing contact info"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderModal, successMessage: 'Billing contact info updated' })));
        };
        _this.renderEditShippingEstimateModal = function (order) {
            var renderModal = function (props) {
                return React.createElement(EditShippingEstimateModal, __assign({ order: order }, props));
            };
            return React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit shipping and handling', labelPosition: 'left' }), onClose: _this.loadOrder },
                React.createElement(Modal.Header, null, "Edit shipping and handling"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderModal, successMessage: 'Shipping and handling edited successfully' })));
        };
        _this.renderQuoteTable = function (order) {
            return React.createElement(Table, { className: 'quote-table', striped: true, celled: true, columns: 2 },
                React.createElement(Table.Body, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.Cell, { style: { fontWeight: 'bold' } }, "Subtotal"),
                        React.createElement(Table.Cell, null, "$" + formatMonetaryDecimal(order.adjustedSubtotalCents))),
                    React.createElement(Table.Row, null,
                        React.createElement(Table.Cell, { style: { fontWeight: 'bold' } }, "Shipping Cost Estimate"),
                        React.createElement(Table.Cell, null, order.shippingCostEstimate != null || order.shippingCostEstimate === 0 ? "$" + formatMonetaryDecimal(order.shippingCostEstimate) : "TBD")),
                    React.createElement(Table.Row, null,
                        React.createElement(Table.Cell, { style: { fontWeight: 'bold' } }, "Handling & Packaging"),
                        React.createElement(Table.Cell, null, "$" + formatMonetaryDecimal(order.handlingAndDryIce)))));
        };
        _this.renderPoUploads = function (order) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Download"),
                        React.createElement(Table.HeaderCell, null, "User"),
                        React.createElement(Table.HeaderCell, null, "PO Number"),
                        React.createElement(Table.HeaderCell, null, "Note"),
                        React.createElement(Table.HeaderCell, null, "Created at"))),
                React.createElement(Table.Body, null, order.poUploads.map(function (po, poIndex) {
                    var renderAddCommentModal = function (props) {
                        return React.createElement(AddOrderPoComment, __assign({ orderId: order.id, poUploadId: po.id }, props));
                    };
                    var addModal = React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'plus', label: 'Add comment', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Add a comment"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderAddCommentModal, successMessage: 'Comment added' })));
                    var downloadUrl = API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(order.id) + "/po-uploads/id/" + encodeURIComponent(po.id);
                    var openWindow = function (event) {
                        // only handle normal button clicks -- allow opening in a tab via middle click
                        if (event.button !== 0) {
                            return;
                        }
                        event.preventDefault();
                        window.open(downloadUrl, 'po', "scrollbars=yes,menubar=yes,toolbar=yes,location=yes,personalbar=yes,status=yes,noopener=yes,resizable=yes");
                    };
                    return React.createElement(React.Fragment, { key: poIndex },
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null,
                                React.createElement("a", { href: downloadUrl, onClick: openWindow },
                                    React.createElement(Icon, { name: 'download' }))),
                            React.createElement(Table.Cell, null, po.attachment.user.name),
                            React.createElement(Table.Cell, null, po.poNum),
                            React.createElement(Table.Cell, null, po.note),
                            React.createElement(Table.Cell, null, displayLocalTimestamp(po.attachment.createdAt))),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, { colspan: 5 },
                                React.createElement("div", { style: {
                                        paddingLeft: '1rem',
                                    } },
                                    po.comments.length > 0 &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("h4", null, "Comments"),
                                            React.createElement(Table, { striped: true, celled: true },
                                                React.createElement(Table.Header, null,
                                                    React.createElement(Table.Row, null,
                                                        React.createElement(Table.HeaderCell, null, "User"),
                                                        React.createElement(Table.HeaderCell, null, "Message"),
                                                        React.createElement(Table.HeaderCell, null, "Created at"))),
                                                React.createElement(Table.Body, null, po.comments.map(function (comment, commentIndex) {
                                                    return React.createElement(Table.Row, { key: commentIndex },
                                                        React.createElement(Table.Cell, null, comment.user.name),
                                                        React.createElement(Table.Cell, { title: comment.msg }, comment.msg),
                                                        React.createElement(Table.Cell, null, displayLocalTimestamp(comment.createdAt)));
                                                })))),
                                    po.comments.length === 0 &&
                                        React.createElement("div", null, "No comments."),
                                    addModal))));
                })));
        };
        _this.renderShipments = function (order) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Shipment"),
                        React.createElement(Table.HeaderCell, null, "Fulfillment Units"),
                        React.createElement(Table.HeaderCell, null, "Note"),
                        React.createElement(Table.HeaderCell, null, "Tracking"),
                        React.createElement(Table.HeaderCell, null, "FedEx Shipment"),
                        React.createElement(Table.HeaderCell, null, "Download Fedex Label"),
                        React.createElement(Table.HeaderCell, null, "Email FedEx Tracking"),
                        React.createElement(Table.HeaderCell, null, "Cost"),
                        React.createElement(Table.HeaderCell, null, "User"),
                        React.createElement(Table.HeaderCell, null, "Packing list"),
                        React.createElement(Table.HeaderCell, null, "Photos"),
                        React.createElement(Table.HeaderCell, null, "Created"))),
                React.createElement(Table.Body, null, order.shipments.map(function (shipment, shipmentIndex) {
                    return React.createElement(Table.Row, { key: shipmentIndex, title: "Shipment id " + shipment.id },
                        React.createElement(Table.Cell, null,
                            "Shipment #",
                            shipmentIndex + 1),
                        React.createElement(Table.Cell, null,
                            React.createElement(List, null, shipment.contents.map(function (content, shipmentContentIndex) {
                                var unit = content.fulfillmentUnit;
                                var kitIndex = order.items
                                    .findIndex(function (i) {
                                    return i.id === unit.itemId;
                                });
                                var item = order.items[kitIndex];
                                var lastVersion = item.versions[item.versions.length - 1];
                                var childNode;
                                if (lastVersion instanceof DeletedVersion) {
                                    childNode = React.createElement(React.Fragment, null,
                                        "(kit since deleted) ",
                                        unit.componentType);
                                }
                                else {
                                    var componentExists = kitComponentExistsInKit(unit.componentType, lastVersion.pricedKit);
                                    childNode =
                                        React.createElement(React.Fragment, null,
                                            React.createElement(KitDisplayModal, { admin: _this.state.condensedKitView, itemIndex: kitIndex, pricedKit: lastVersion.pricedKit, trigger: React.createElement(Button, { icon: 'eye', size: 'mini' }) }),
                                            unit.componentType,
                                            componentExists
                                                ? ''
                                                : ' (component since deleted)');
                                }
                                return React.createElement(List.Item, { key: shipmentContentIndex, title: "Item " + unit.itemId },
                                    "Kit #",
                                    kitIndex + 1,
                                    " ",
                                    childNode,
                                    " ",
                                    content.completesUnit
                                        ? React.createElement(Icon, { style: { display: 'inline', lineHeight: '150%' }, name: 'check' })
                                        : '');
                            }))),
                        React.createElement(Table.Cell, null, shipment.note ? shipment.note : ''),
                        React.createElement(Table.Cell, null, shipment.tracking
                            ? linkifyTracking(shipment.tracking)
                            : React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'plus', label: 'Add', disabled: order.onHold, labelPosition: 'left' }), onClose: _this.loadOrder },
                                React.createElement(Modal.Header, null, "Add tracking"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(AddShipmentTrackingModal, { orderId: order.id, shipmentId: shipment.id })))),
                        React.createElement(Table.Cell, null, (shipment.tracking == null) ? React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'plus', positive: true, disabled: order.onHold, label: 'Create Shipping Label', labelPosition: 'left' }), onClose: _this.loadOrder },
                            React.createElement(Modal.Header, null, "Create Shipping Label"),
                            React.createElement(Modal.Content, null,
                                React.createElement(SimpleFormWithErrorDisplay, { render: _this.createShippingLabelModal(order, shipment), successMessage: 'Created Shipping Label' }))) : (!shipment.canceled ? React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { disabled: shipment.emailedTracking, icon: 'x', negative: true, label: 'Cancel shipment', labelPosition: 'left' }), onClose: _this.loadOrder },
                            React.createElement(Modal.Header, null, "Cancel Shipment"),
                            React.createElement(Modal.Content, null,
                                React.createElement(SimpleFormWithErrorDisplay, { render: _this.cancelShipmentModal(order.id, shipment.id, shipment.tracking), successMessage: 'Shipment successfully cancelled' }))) : 'Canceled')),
                        React.createElement(Table.Cell, null, (shipment.label != null && !shipment.canceled) &&
                            React.createElement("a", { href: API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(order.id) + "/shipments/id/" + encodeURIComponent(shipment.id) + "/fedex-label/id/" + encodeURIComponent(shipment.label.id), target: "_blank" },
                                React.createElement(Button, { icon: 'download', label: 'Download FedEx label', labelPosition: 'left' }))),
                        React.createElement(Table.Cell, null, (!shipment.canceled && shipment.tracking != null) &&
                            React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { disabled: shipment.emailedTracking, icon: 'mail', label: 'Email tracking number', labelPosition: 'left' }), onClose: _this.loadOrder },
                                React.createElement(Modal.Header, null, "Email Tracking Number"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(Modal.Description, null, "Send email to the user and billing contact to track FedEx shipment."),
                                    React.createElement(SendTrackingNumberModal, { orderId: order.id, shipmentId: shipment.id })))),
                        React.createElement(Table.Cell, null, shipment.costCents ? "" + formatMonetaryDecimal(shipment.costCents) : ''),
                        React.createElement(Table.Cell, null, shipment.user.name),
                        React.createElement(Table.Cell, null, _this.printPackingListButton(shipment)),
                        React.createElement(Table.Cell, null,
                            shipment.photos.length > 0
                                ? React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'eye', label: shipment.photos.length + " photos", labelPosition: 'left' }) },
                                    React.createElement(Modal.Header, null, "Photos"),
                                    React.createElement(Modal.Content, null,
                                        React.createElement(ViewShipmentPhotosModal, { orderId: order.id, shipmentId: shipment.id, photos: shipment.photos })))
                                : React.createElement(React.Fragment, null),
                            React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'camera', label: 'Add', labelPosition: 'left' }), onClose: _this.loadOrder },
                                React.createElement(Modal.Header, null, "Add photos"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(Modal.Description, null, "Multiple photos can be added at once."),
                                    React.createElement(UploadShipmentPhotoModal, { orderId: order.id, shipmentId: shipment.id })))),
                        React.createElement(Table.Cell, null, displayLocalTimestamp(shipment.createdAt)));
                })));
        };
        _this.createShippingLabelModal = function (order, shipment) {
            return function (props) {
                return React.createElement(CreateShipmentModal, __assign({ order: order, shipmentId: shipment.id, shippingAddress: order.shippingAddress, customerName: order.user.name, companyName: order.user.organization, recipientNumber: order.user.phoneNumber, poNums: order.poUploads.map(function (po) { return po.poNum; }) }, props));
            };
        };
        _this.cancelShipmentModal = function (orderId, shipmentId, trackingNumber) {
            return function (props) {
                return React.createElement(CancelShipmentModal, __assign({ orderId: orderId, shipmentId: shipmentId, trackingNumber: trackingNumber }, props));
            };
        };
        _this.condensedKitViewToggle = function () {
            _this.setState(function (s) {
                return {
                    condensedKitView: !s.condensedKitView
                };
            });
        };
        _this.setItemQuantity = function (order, item, quantity) {
            postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(order.id) + "/items/id/" + item.id + "/quantity", JSON.stringify({ quantity: quantity }))
                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                var body, unassigned;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!resp.ok) return [3 /*break*/, 1];
                            console.error("Couldn't update quantity: " + resp.status);
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, resp.json()];
                        case 2:
                            body = _b.sent();
                            unassigned = (_a = body.unassignedProbeLots) !== null && _a !== void 0 ? _a : [];
                            this.setState({
                                quantityWarnings: unassigned.map(function (lot) {
                                    return "Quantity " + quantity + " exceeds the remaining inventory of probe lot " +
                                        (lot.lotNumber + " (channel " + lot.channel + "), so the lot was unassigned. ") +
                                        ("Assign a lot with enough inventory to cover all " + quantity + " kits.");
                                })
                            });
                            _b.label = 3;
                        case 3:
                            this.loadOrder();
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (rej) {
                console.error("Couldn't update quantity: " + rej);
            });
        };
        _this.renderOrderItems = function (order) {
            var renderErrors = function (errors) { return React.createElement(AllErrorDisplay, { errors: errors }); };
            return order.items.map(function (item, index) {
                var _a;
                var reversedVersions = item.versions.slice().reverse();
                var panels = reversedVersions.map(function (v, versIndex) {
                    var element;
                    if (v instanceof DeletedVersion) {
                        element = React.createElement(React.Fragment, null, "(Deleted)");
                    }
                    else {
                        element = React.createElement(KitDisplay, { pricedKit: v.pricedKit, displayBlastLink: true, admin: _this.state.condensedKitView, quantity: item.quantity });
                    }
                    return {
                        title: {
                            content: "Version " + (item.versions.length - versIndex),
                            key: "title-" + versIndex
                        },
                        content: {
                            content: element,
                            key: "content-" + versIndex
                        },
                        key: versIndex
                    };
                });
                // use the last non-deleted one as the starting point for editing
                var lastNonDeleted = reversedVersions.find(function (v) { return v instanceof ExistingVersion; });
                if (!(lastNonDeleted instanceof ExistingVersion)) {
                    throw new Error("Kit with no existing item versions");
                }
                var kit = lastNonDeleted.pricedKit.kit;
                var kitPrice = lastNonDeleted.pricedKit.price;
                var kitType = determineKitType(kit);
                var renderEditModal = function (catalog) {
                    return React.createElement(InternalUserEditKitModal, { catalog: catalog, endpoint: "/admin/orders/id/" + encodeURIComponent(order.id) + "/items/id/" + item.id, kitType: kitType, negativeControlProbe: false, initialRnaFishFormState: kit instanceof RnaFishKit
                            ? rnaFishKitToFormState(catalog.rnaCatalog, kit, true, kitPrice)
                            : defaultFormState(catalog.rnaCatalog, kitType === KitType.LegacyRnaFish), initialSecondaryIfFormState: kit instanceof SecondaryIfKit
                            ? secondaryIfKitToFormState(catalog.secondaryIfCatalog, kit, true, kitPrice)
                            : defaultSecondaryIfFormState(catalog.secondaryIfCatalog, kitType === KitType.LegacyIhc2), initialRnaCishFormState: kit instanceof AutomatedProKit
                            ? rnaCishKitToAdminFormState(catalog.rnaCatalog, kit, kitPrice)
                            : defaultAdminAutomatedProFormState(catalog.rnaCatalog), initialManualProFormState: kit instanceof ManualProKit
                            ? manualProKitToAdminFormState(catalog.rnaCatalog, kit, kitPrice)
                            : defaultManualProAdminFormState(catalog.rnaCatalog), initialEncoderFormState: kit instanceof ManualGoldIfKit
                            ? encoderKitToFormState(catalog.secondaryIfCatalog, kit, true, kitPrice)
                            : defaultManualGoldIfFormState(catalog.secondaryIfCatalog), initialAutomatedIfFormState: kit instanceof AutomatedGoldIfKit
                            ? automatedIfKitToFormState(catalog.secondaryIfCatalog, kit, kitPrice)
                            : defaultAutomatedIfFormState(catalog.secondaryIfCatalog), loadPricesOnMount: true, orderId: order.id });
                };
                var renderDesignDiffModal = function (probeSet) {
                    var _a;
                    var differs = _this.customerFieldsDifferFromProbeDeisgn(probeSet);
                    return React.createElement(Modal, { trigger: React.createElement(Button, { icon: differs ? 'warning' : 'eye', color: differs ? 'yellow' : 'green', label: "Probe Design v.s. Customer Input" }) },
                        React.createElement(Modal.Content, null,
                            React.createElement(Table, null,
                                React.createElement(Table.Header, null,
                                    React.createElement(Table.HeaderCell, null),
                                    React.createElement(Table.HeaderCell, null, "Customer Provided Input"),
                                    React.createElement(Table.HeaderCell, null, "Probe Design Value")),
                                React.createElement(Table.Body, null,
                                    React.createElement(Table.Row, null,
                                        React.createElement(Table.Cell, null, "Organism Diff"),
                                        React.createElement(Table.Cell, null, probeSet.customerOrganismName),
                                        React.createElement(Table.Cell, null, probeSet.organism.displayName())),
                                    React.createElement(Table.Row, null,
                                        React.createElement(Table.Cell, null, "Target Diff"),
                                        React.createElement(Table.Cell, null, probeSet.customerTargetName),
                                        React.createElement(Table.Cell, null, probeSet.probeSetFamily.displayName())),
                                    React.createElement(Table.Row, null,
                                        React.createElement(Table.Cell, null, "Sequence Diff"),
                                        React.createElement(Table.Cell, null, abbreviateRnaWithModal(probeSet.customerSequence, true)),
                                        React.createElement(Table.Cell, null, abbreviateRnaWithModal(probeSet.variant.targetMrnaSeq, true))),
                                    React.createElement(Table.Row, null,
                                        React.createElement(Table.Cell, null, "Accession Diff"),
                                        React.createElement(Table.Cell, null, probeSet.customerAccessionNum),
                                        React.createElement(Table.Cell, null, ((_a = probeSet.variant.accession) === null || _a === void 0 ? void 0 : _a.accessionNum) ? probeSet.variant.accession.accessionNum : "")),
                                    React.createElement(Table.Row, null,
                                        React.createElement(Table.Cell, null, "Probe Size Diff"),
                                        React.createElement(Table.Cell, null,
                                            numOfBindingSitesDisplay(probeSet.customerProbeSetSize),
                                            React.createElement("br", null),
                                            probeSet.customerProbeSetSize),
                                        React.createElement(Table.Cell, null, probeSet.variant.probeSetSize))))));
                };
                var product;
                var variantDesignerNodes = [];
                var editProbeLotNodes = [];
                var designNumberNodes = [];
                var designCommentNodes = [];
                if ((lastNonDeleted.pricedKit instanceof RnaFishPricedKit && lastNonDeleted.pricedKit.kit.probeSetComponent !== undefined) ||
                    (lastNonDeleted.pricedKit instanceof PricedManualProKit && lastNonDeleted.pricedKit.kit.probeSet !== undefined)) {
                    product = 'RnaFish';
                    var probeSetComponent_1 = lastNonDeleted.pricedKit instanceof RnaFishPricedKit
                        ? lastNonDeleted.pricedKit.kit.probeSetComponent : lastNonDeleted.pricedKit.kit.probeSet;
                    var probeSet_1 = probeSetComponent_1.probeSet;
                    designCommentNodes.push(React.createElement(ProbeDesignCommentModal, { key: 'design-comment-1', orderId: order.id, itemId: item.id, channel: 1 }));
                    if (probeSet_1 instanceof SimpleCatalogVariantProbeSet) {
                        var assignKitToProbeLotLoadWrapper = function (props) {
                            var renderAssignKitToProbeLotModal = function (catalog) {
                                // todo ugly
                                var fishKit = kit instanceof RnaFishKit ? kit : undefined;
                                var fishKitPrice = kitPrice instanceof RnaFishKitPrice ? kitPrice : undefined;
                                var manualProKit = kit instanceof ManualProKit ? kit : undefined;
                                var manualProKitPrice = kitPrice instanceof ManualProPrice ? kitPrice : undefined;
                                return React.createElement(AssignKitToProbeLotModal, __assign({ probeSet: probeSet_1, item: item, orderId: order.id, rnaFishProbeSetComponent: probeSetComponent_1, channel: Channel.Channel1, catalog: catalog.rnaCatalog, rnaFishKit: fishKit, rnaFishKitPrice: fishKitPrice, manualProKit: manualProKit, manualProKitPrice: manualProKitPrice }, props));
                            };
                            return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id), render: renderAssignKitToProbeLotModal });
                        };
                        designNumberNodes.push(React.createElement(React.Fragment, { key: "design-rnafish" },
                            React.createElement(Header, null, "Variant: "),
                            React.createElement("p", null, probeSet_1.variant.name),
                            React.createElement(Header, null, " Design Number: "),
                            React.createElement("p", null, (_a = probeSet_1.variant.designNumber) !== null && _a !== void 0 ? _a : 'pending'),
                            renderDesignDiffModal(probeSet_1)));
                        var header = (lastNonDeleted.pricedKit.kit instanceof RnaFishKit && lastNonDeleted.pricedKit.kit.legacy) ? "v3.0" : "HiFi";
                        editProbeLotNodes.push(React.createElement(Modal, { key: "probelot-rnafish", closeIcon: true, trigger: React.createElement(Button, { icon: 'exchange', label: probeSet_1.probeLotNumber ? "Assigned Probe Lot: " + probeSet_1.probeLotNumber : "Assign Probe Lot", labelPosition: 'left' }), onClose: _this.loadOrder },
                            React.createElement(Modal.Header, null,
                                "Select ",
                                header,
                                " Probe Lot"),
                            React.createElement(Modal.Content, null,
                                React.createElement(SimpleFormWithErrorDisplay, { render: assignKitToProbeLotLoadWrapper, successMessage: 'Probe lot assigned', errorDisplay: renderErrors }))));
                    }
                    var variantDesignerLoadWrapper = function (props) {
                        var renderVariantDesignerModal = function (catalog) {
                            return React.createElement(AddToCatalogContainerModal, __assign({ orderId: order.id, channel: 1, probeSet: probeSet_1, catalog: catalog.rnaCatalog, kit: kit, kitPrice: kitPrice, item: item }, props));
                        };
                        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id), render: renderVariantDesignerModal });
                    };
                    variantDesignerNodes.push(React.createElement(Modal, { key: "variant-rnafish", closeIcon: true, trigger: React.createElement(Button, { icon: 'book', label: 'Variant Designer', labelPosition: 'left' }), onClose: _this.loadOrder },
                        React.createElement(Modal.Header, null, "Variant Designer"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: variantDesignerLoadWrapper, successMessage: 'Variant updated', errorDisplay: renderErrors }))));
                }
                if (lastNonDeleted.pricedKit instanceof AutomatedProPricedKit) {
                    product = 'RnaCish';
                    var automatedProKit_1 = lastNonDeleted.pricedKit.kit;
                    var automatedProPrice_1 = lastNonDeleted.pricedKit.price;
                    automatedProKit_1.probeSetComponent
                        .sort(function (c1, c2) { return c1.channel - c2.channel; })
                        .forEach(function (probeSetComponent) {
                        var channel = probeSetComponent.channel;
                        variantDesignerNodes.push(React.createElement(React.Fragment, { key: "variant-" + channel }, _this.renderVariantDesignerNode(order, automatedProKit_1, automatedProPrice_1, item, channel, renderErrors, probeSetComponent)));
                        editProbeLotNodes.push(React.createElement(React.Fragment, { key: "probelot-" + channel }, _this.renderEditProbeLotNode(order, automatedProKit_1, automatedProPrice_1, item, channel, renderErrors, probeSetComponent)));
                        designNumberNodes.push(React.createElement(React.Fragment, { key: "design-" + channel }, _this.renderDesignNumberNode(channel, probeSetComponent)));
                        designCommentNodes.push(React.createElement(ProbeDesignCommentModal, { key: "design-comment-" + channel, orderId: order.id, itemId: item.id, channel: channel, multiplex: automatedProKit_1.probeSetComponent.length > 1 }));
                    });
                }
                return React.createElement(Segment, { key: index },
                    React.createElement(KitIndexHeader, { itemIndex: index, kit: lastNonDeleted.pricedKit.kit, adminView: true }),
                    React.createElement(Accordion, { defaultActiveIndex: [0], exclusive: false, panels: panels }),
                    React.createElement("div", { style: { marginTop: '2rem' } },
                        React.createElement(Button.Group, { style: { marginRight: '3.5px' } },
                            React.createElement(Button, { icon: 'minus', disabled: _this.orderItemsNotEditable() || item.quantity <= 1, onClick: function () { return _this.setItemQuantity(order, item, item.quantity - 1); } }),
                            React.createElement(Button, { basic: true, content: "" + item.quantity }),
                            React.createElement(Button, { icon: 'plus', disabled: _this.orderItemsNotEditable(), onClick: function () { return _this.setItemQuantity(order, item, item.quantity + 1); } })),
                        React.createElement(Help, null, "Number of identical kits this line represents. Delete the kit to remove the line."),
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit kit', labelPosition: 'left', disabled: _this.orderItemsNotEditable() }), onClose: _this.loadOrder, size: 'large' },
                            React.createElement(Modal.Header, null, "Edit kit"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id, product), render: renderEditModal }))),
                        React.createElement(Help, null, "Create a new version based on the most recent non-deleted kit"),
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'trash', label: 'Delete kit', negative: true, labelPosition: 'left', disabled: _this.orderItemsNotEditable() }), onClose: _this.loadOrder },
                            React.createElement(Modal.Header, null, "Delete kit"),
                            React.createElement(Modal.Content, null,
                                React.createElement(DeleteKitConfirmation, { itemId: item.id, 
                                    // TS fail: it thinks response can be undefined here
                                    orderId: order.id }))),
                        React.createElement(Help, null, "Create a new version that marks the kit as deleted."),
                        variantDesignerNodes,
                        editProbeLotNodes,
                        designCommentNodes,
                        React.createElement("br", null),
                        designNumberNodes));
            });
        };
        _this.renderLineItems = function (order) {
            var renderModal = function (props) {
                return React.createElement(AddLineItemModal, __assign({ orderId: order.id }, props));
            };
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Line items"),
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Type"),
                            React.createElement(Table.HeaderCell, null, "User"),
                            React.createElement(Table.HeaderCell, null, "Note"),
                            React.createElement(Table.HeaderCell, null, "Amount"),
                            React.createElement(Table.HeaderCell, null, "Created at"),
                            React.createElement(Table.HeaderCell, null, "Delete"))),
                    React.createElement(Table.Body, null, order.lineItems.map(function (lineItem, index) {
                        var renderDeleteModal = function (props) {
                            return React.createElement(DeleteLineItemModal, __assign({ orderId: order.id, lineItemId: lineItem.id }, props));
                        };
                        return React.createElement(Table.Row, { key: index },
                            React.createElement(Table.Cell, null, lineItem.type),
                            React.createElement(Table.Cell, null, lineItem.user.name),
                            React.createElement(Table.Cell, { title: lineItem.note }, lineItem.note),
                            React.createElement(Table.Cell, null,
                                "$",
                                formatMonetaryDecimal(lineItem.amountCents)),
                            React.createElement(Table.Cell, null, displayLocalTimestamp(lineItem.createdAt)),
                            React.createElement(Table.Cell, null,
                                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'trash', label: 'Delete line item', labelPosition: 'left', negative: true }), onClose: _this.loadOrder },
                                    React.createElement(Modal.Header, null, "Delete line item"),
                                    React.createElement(Modal.Content, null,
                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderDeleteModal, successMessage: "Line item deleted" })))));
                    }))),
                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'plus', label: 'Add line item', labelPosition: 'left' }), onClose: _this.loadOrder },
                    React.createElement(Modal.Header, null, "Add line item"),
                    React.createElement(Modal.Content, null,
                        React.createElement(SimpleFormWithErrorDisplay, { render: renderModal, successMessage: "Line item added" }))));
        };
        _this.renderVariantDesignerNode = function (order, kit, kitPrice, item, channel, renderErrors, probeSetComponent) {
            if (probeSetComponent != null) {
                var variantDesignerLoadWrapper = function (props) {
                    var renderVariantDesignerModal = function (catalog) {
                        return React.createElement(AddToCatalogContainerModal, __assign({ orderId: order.id, probeSet: probeSetComponent.probeSet, channel: channel, catalog: catalog.rnaCatalog, kit: kit, kitPrice: kitPrice, item: item }, props));
                    };
                    return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id), render: renderVariantDesignerModal });
                };
                var designerLabel = channel === Channel.Channel1 ? "Variant 1 Designer" : "Variant 2 Designer";
                return React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'book', label: designerLabel, labelPosition: 'left' }), onClose: _this.loadOrder },
                    React.createElement(Modal.Header, null, "Variant Designer"),
                    React.createElement(Modal.Content, null,
                        React.createElement(SimpleFormWithErrorDisplay, { render: variantDesignerLoadWrapper, successMessage: 'Variant updated', errorDisplay: renderErrors })));
            }
            return React.createElement(React.Fragment, null);
        };
        _this.renderEditProbeLotNode = function (order, kit, kitPrice, item, channel, renderErrors, probeSetComponent) {
            var probeSet = probeSetComponent === null || probeSetComponent === void 0 ? void 0 : probeSetComponent.probeSet;
            if (probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet ||
                probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet) {
                if (probeSet.probeLotNumber) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(Button, { icon: 'exchange', label: "Assigned Probe Lot " + channel + ": " + probeSet.probeLotNumber, labelPosition: 'left', disabled: true }),
                        React.createElement("br", null),
                        React.createElement(Message, { warning: true, content: "Custom kits need to be added to the catalog before a probe lot can be assigned." }));
                }
                else {
                    return React.createElement(React.Fragment, null,
                        React.createElement(Message, { warning: true, content: "Custom kits need to be added to the catalog before a probe lot can be assigned." }));
                }
            }
            if (probeSet instanceof SimpleCatalogVariantProbeSet) {
                var assignKitToProbeLotLoadWrapper = function (props) {
                    var renderAssignKitToProbeLotModal = function (catalog) {
                        return React.createElement(AssignKitToProbeLotModal, __assign({ probeSet: probeSet, item: item, orderId: order.id, channel: channel, rnaCishProbeSetComponent: probeSetComponent, catalog: catalog.rnaCatalog, automatedPro: kit, automatedProKitPrice: kitPrice }, props));
                    };
                    return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id), render: renderAssignKitToProbeLotModal });
                };
                return React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'exchange', label: probeSet.probeLotNumber ? "Assigned Probe Lot " + channel + ": " + probeSet.probeLotNumber : "Assign Probe Lot " + channel, labelPosition: 'left' }), onClose: _this.loadOrder },
                    React.createElement(Modal.Header, null, "Select Probe Lot"),
                    React.createElement(Modal.Content, null,
                        React.createElement(SimpleFormWithErrorDisplay, { render: assignKitToProbeLotLoadWrapper, successMessage: 'Probe lot assigned', errorDisplay: renderErrors })));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.renderDesignNumberNode = function (channel, probeSetComponent) {
            var _a;
            var probeSet = probeSetComponent === null || probeSetComponent === void 0 ? void 0 : probeSetComponent.probeSet;
            if (probeSet instanceof SimpleCatalogVariantProbeSet) {
                return React.createElement(React.Fragment, null,
                    React.createElement(Header, null,
                        "Variant ",
                        channel,
                        ": ",
                        probeSet.variant.name),
                    React.createElement(Header, null,
                        " Design Number: ", (_a = probeSet.variant.designNumber) !== null && _a !== void 0 ? _a : 'pending'),
                    _this.renderDesignDiffModal(probeSet));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.renderDesignDiffModal = function (probeSet) {
            var _a;
            var differs = _this.customerFieldsDifferFromProbeDeisgn(probeSet);
            return React.createElement(Modal, { trigger: React.createElement(Button, { icon: differs ? 'warning' : 'eye', color: differs ? 'yellow' : 'green', label: "Probe Design v.s. Customer Input" }) },
                React.createElement(Modal.Content, null,
                    React.createElement(Table, null,
                        React.createElement(Table.Header, null,
                            React.createElement(Table.HeaderCell, null),
                            React.createElement(Table.HeaderCell, null, "Customer Provided Input"),
                            React.createElement(Table.HeaderCell, null, "Probe Design Value")),
                        React.createElement(Table.Body, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.Cell, null, "Organism Diff"),
                                React.createElement(Table.Cell, null, probeSet.customerOrganismName),
                                React.createElement(Table.Cell, null, probeSet.organism.displayName())),
                            React.createElement(Table.Row, null,
                                React.createElement(Table.Cell, null, "Target Diff"),
                                React.createElement(Table.Cell, null, probeSet.customerTargetName),
                                React.createElement(Table.Cell, null, probeSet.probeSetFamily.displayName())),
                            React.createElement(Table.Row, null,
                                React.createElement(Table.Cell, null, "Sequence Diff"),
                                React.createElement(Table.Cell, null, abbreviateRnaWithModal(probeSet.customerSequence, true)),
                                React.createElement(Table.Cell, null, abbreviateRnaWithModal(probeSet.variant.targetMrnaSeq, true))),
                            React.createElement(Table.Row, null,
                                React.createElement(Table.Cell, null, "Accession Diff"),
                                React.createElement(Table.Cell, null, probeSet.customerAccessionNum),
                                React.createElement(Table.Cell, null, ((_a = probeSet.variant.accession) === null || _a === void 0 ? void 0 : _a.accessionNum) ? probeSet.variant.accession.accessionNum : "")),
                            React.createElement(Table.Row, null,
                                React.createElement(Table.Cell, null, "Probe Size Diff"),
                                React.createElement(Table.Cell, null,
                                    numOfBindingSitesDisplay(probeSet.customerProbeSetSize),
                                    React.createElement("br", null),
                                    probeSet.customerProbeSetSize),
                                React.createElement(Table.Cell, null, probeSet.variant.probeSetSize))))));
        };
        _this.editPoApprovalTypeButton = function (orderResponse) {
            var renderModalContents = function (props) {
                return React.createElement(ChangePoApprovalType, __assign({ orderId: orderResponse.order.id, currentPoApprovalType: orderResponse.order.poApprovalType, poApprovalTypes: orderResponse.poApprovalTypes }, props));
            };
            return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: labelWidth },
                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit PO approval type', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Add a comment"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderModalContents, successMessage: 'Approval type changed' })))));
        };
        _this.editAutomatedActionList = function (orderResponse) {
            var renderModalContents = function (props) {
                return React.createElement(ChangeAutomatedActionStatus, __assign({ resourceId: orderResponse.order.id, userLevel: false, currentAutomatedActionStatus: orderResponse.order.automatedActions, automatedActionOptions: orderResponse.automatedActions }, props));
            };
            return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: labelWidth },
                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit Automated Actions', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Edit"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderModalContents, successMessage: 'Successfully Changed Automated Actions List' })))));
        };
        _this.printPackingListButton = function (s) {
            var openWindowWithPackingSlip = function () {
                var url = API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(_this.props.match.params.id) + "/shipments/id/" + encodeURIComponent(s.id) + "/packing-slip?siteBase=" + encodeURIComponent(ORIGIN === "hcr" ? "hcr" : "mi");
                window.open(url, 'packing-slip');
            };
            return React.createElement(Button, { icon: 'print', onClick: openWindowWithPackingSlip });
        };
        _this.displayAddress = function (address) {
            return React.createElement(React.Fragment, null,
                React.createElement("p", null, address.street),
                React.createElement("p", null, address.streetLine2),
                React.createElement("p", null, address.city),
                React.createElement("p", null, address.stateProvince),
                React.createElement("p", null, address.zipPostalCode),
                React.createElement("p", null, address.countryCode));
        };
        _this.customerFieldsDifferFromProbeDeisgn = function (probeSet) {
            var accession = probeSet.variant.accession ? probeSet.variant.accession.accessionNum : "";
            return probeSet.customerOrganismName !== probeSet.organism.displayName() ||
                probeSet.customerTargetName !== probeSet.probeSetFamily.displayName() ||
                probeSet.customerSequence !== probeSet.variant.targetMrnaSeq ||
                probeSet.customerProbeSetSize !== probeSet.variant.probeSetSize ||
                probeSet.customerAccessionNum.trim() !== accession;
        };
        _this.loadOrder = function () {
            _this.setState({ orderLoading: true }, function () {
                getWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.match.params.id))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                }).then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            orderLoading: false,
                            error: true
                        });
                    }
                    else {
                        var jsonOrder = resp.order;
                        var items = jsonOrder.items.map(function (i) {
                            var versions = i.versions.map(function (v) {
                                if (v._type === 'deleted') {
                                    return new DeletedVersion();
                                }
                                else if (v._type === 'existing') {
                                    return new ExistingVersion(KitDeserializer.deserializePricedKit(v.pricedKit));
                                }
                                else {
                                    throw new Error("Unexpected type " + v._type);
                                }
                            });
                            return {
                                id: i.id,
                                quantity: i.quantity,
                                versions: versions
                            };
                        });
                        var shipments = jsonOrder.shipments.map(function (s) { return (__assign(__assign({}, s), { contents: s.contents.map(function (c) {
                                var componentType = allKitComponentTypes.find(function (t) { return t === c.fulfillmentUnit.componentType; });
                                if (componentType === undefined) {
                                    throw new Error("Unknown component type " + c.fulfillmentUnit.componentType);
                                }
                                return (__assign(__assign({}, c), { fulfillmentUnit: new FulfillmentUnit(c.fulfillmentUnit.itemId, componentType) }));
                            }) })); });
                        var order = __assign(__assign({}, jsonOrder), { items: items,
                            shipments: shipments });
                        _this.setState({
                            error: false,
                            orderResponse: {
                                order: order,
                                accountEmail: resp.accountEmail,
                                pmtStatusTransitions: resp.pmtStatusTransitions,
                                prodStatusTransitions: resp.prodStatusTransitions,
                                automatedActions: resp.automatedActions,
                                poApprovalTypes: resp.poApprovalTypes,
                                principalUserId: resp.principalUserId
                            },
                            orderLoading: false
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't load orders: " + rej);
                });
            });
        };
        _this.reorder = function (order) {
            var renderReorderConfirmation = function (catalog) { return function (props) {
                return React.createElement(ReorderModal, __assign({ order: order, catalog: catalog }, props));
            }; };
            var renderSimpleFormWithErrorDisplay = function (catalog) {
                return React.createElement(SimpleFormWithErrorDisplay, { render: renderReorderConfirmation(catalog), successMessage: 'Order reordered' });
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'cart', label: 'Reorder', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Confirm Reorder"),
                React.createElement(Modal.Content, null,
                    React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, order.id), render: renderSimpleFormWithErrorDisplay })));
        };
        _this.state = {
            error: false,
            orderLoading: false,
            condensedKitView: false,
            activeKitModalType: null,
            selectedKitOption: ''
        };
        return _this;
    }
    SingleOrderPage.prototype.render = function () {
        var _this = this;
        var _a;
        return React.createElement(Dimmer.Dimmable, { as: 'div', id: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.orderLoading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Order could not be loaded."),
            this.state.orderResponse &&
                React.createElement(React.Fragment, null,
                    React.createElement(PizzaTracker, { statuses: this.state.orderResponse.order.trackingStatuses, lastUpdated: this.state.orderResponse.order.lastUpdated, estShippingDate: this.state.orderResponse.order.estShippingDate, trackingLinks: this.state.orderResponse.order.trackingLinks }),
                    React.createElement(Header, null,
                        "Order ",
                        this.state.orderResponse.order.id,
                        this.state.orderResponse.order.isModified ? ' (updated)' : ''),
                    React.createElement(Grid, { className: 'tight-rows' },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Created by"),
                            React.createElement(Grid.Column, { width: valueWidth },
                                React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + encodeURIComponent(this.state.orderResponse.order.user.id) },
                                    this.state.orderResponse.order.user.name,
                                    " (",
                                    this.state.orderResponse.order.user.id,
                                    ")"))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "User notes"),
                            React.createElement(Grid.Column, { width: valueWidth },
                                React.createElement("pre", { className: 'text-with-whitespace', style: { borderLeft: '2px solid #ccc', padding: '0.3rem 0.6rem' } }, this.state.orderResponse.order.user.notes))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Order nickname"),
                            React.createElement(Grid.Column, { width: valueWidth },
                                React.createElement("pre", { className: 'text-with-whitespace', style: { borderLeft: '2px solid #ccc', padding: '0.3rem 0.6rem' } }, this.state.orderResponse.order.nickname))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Courier Account #"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.order.user.courierAccountNumber || 'None')),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Created at"),
                            React.createElement(Grid.Column, { width: valueWidth }, displayLocalTimestamp(this.state.orderResponse.order.createdAt))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Payment status"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.order.pmtStatus)),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Production status"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.order.prodStatus)),
                        (this.state.orderResponse.order.holdStart && this.state.orderResponse.order.holdEnd) && !this.state.orderResponse.order.hideHoldDates &&
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: labelWidth }, "Hold Dates"),
                                React.createElement(Grid.Column, { width: valueWidth },
                                    React.createElement(Message, { content: React.createElement(React.Fragment, null,
                                            "Ship before ",
                                            React.createElement("b", null, this.state.orderResponse.order.holdStart),
                                            " or after ",
                                            React.createElement("b", null, this.state.orderResponse.order.holdEnd)), color: 'red' }))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth },
                                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit status', labelPosition: 'left' }), onClose: this.loadOrder },
                                    React.createElement(Modal.Header, null, "Edit order status"),
                                    React.createElement(Modal.Content, null,
                                        React.createElement(StatusEditModal, { orderId: this.state.orderResponse.order.id, initialPmtStatus: this.state.orderResponse.order.pmtStatus, initialProdStatus: this.state.orderResponse.order.prodStatus, pmtStatusTransitions: this.state.orderResponse.pmtStatusTransitions, prodStatusTransitions: this.state.orderResponse.prodStatusTransitions }))))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "PO approval type"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.order.poApprovalType)),
                        this.editPoApprovalTypeButton(this.state.orderResponse),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, this.editAutomatedActionList(this.state.orderResponse)),
                            React.createElement(Grid.Column, { width: valueWidth },
                                React.createElement("b", null, this.state.orderResponse.order.automatedActions.map(function (a, index) {
                                    return React.createElement(React.Fragment, { key: index },
                                        a,
                                        React.createElement("br", null));
                                })))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Kit Subtotal"),
                            React.createElement(Grid.Column, { width: valueWidth },
                                "$",
                                formatMonetaryDecimal(this.state.orderResponse.order.kitSubtotalCents))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Adjusted Subtotal"),
                            React.createElement(Grid.Column, { width: valueWidth },
                                "$",
                                formatMonetaryDecimal(this.state.orderResponse.order.adjustedSubtotalCents))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Shipping address"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.displayAddress(this.state.orderResponse.order.shippingAddress))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Billing address"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.displayAddress(this.state.orderResponse.order.billingAddress))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: valueWidth },
                                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit address', labelPosition: 'left' }), onClose: this.loadOrder },
                                    React.createElement(Modal.Header, null, "Edit addresses"),
                                    React.createElement(Modal.Content, null,
                                        React.createElement(EditAddressesModal, { initialShippingAddress: this.state.orderResponse.order.shippingAddress, initialBillingAddress: this.state.orderResponse.order.billingAddress, orderId: this.state.orderResponse.order.id }))))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Account Email"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.accountEmail)),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: labelWidth }, "Billing email"),
                            React.createElement(Grid.Column, { width: valueWidth }, this.state.orderResponse.order.billingEmail)),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: valueWidth }, this.renderEditBillingContactInfoModal(this.state.orderResponse.order)))),
                    React.createElement(Header, null, "Shipments"),
                    this.renderShipments(this.state.orderResponse.order),
                    this.state.orderResponse.order.onHold && React.createElement(Message, { color: 'yellow', content: 'Order is on hold' }),
                    React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'box', label: 'Add shipment', labelPosition: 'left' }), onClose: this.loadOrder },
                        React.createElement(Modal.Header, null, "Add shipment"),
                        React.createElement(Modal.Content, null,
                            React.createElement(AddShipmentModal, { order: this.state.orderResponse.order }))),
                    React.createElement(Header, null, "Quote & PO uploads"),
                    this.renderQuoteTable(this.state.orderResponse.order),
                    React.createElement("div", { style: { marginTop: '1rem' } },
                        this.renderEditShippingEstimateModal(this.state.orderResponse.order),
                        React.createElement("a", { href: API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(this.state.orderResponse.order.id) + "/quote-pdf", target: "_blank" },
                            React.createElement(Button, { icon: 'download', label: 'Download Quote PDF', labelPosition: 'left' }))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'mail', label: 'Email PO reminder', labelPosition: 'left' }), onClose: this.loadOrder },
                            React.createElement(Modal.Header, null, "Email PO Reminder"),
                            React.createElement(Modal.Content, null,
                                React.createElement(Modal.Description, null, "Send a mail to the user and billing contact reminding them to submit a PO."),
                                React.createElement(SendPoReminderModal, { orderId: this.state.orderResponse.order.id })))),
                    this.renderPoUploads(this.state.orderResponse.order),
                    React.createElement(Header, null, "Order Comments"),
                    React.createElement(AddCommentModal, { orderId: this.state.orderResponse.order.id, onSubmit: this.loadOrder }),
                    React.createElement("br", null),
                    React.createElement(ReactTable, { columns: [
                            {
                                id: 'name',
                                Header: 'User',
                                accessor: function (e) { return e.user.name; }
                            },
                            {
                                id: 'msg',
                                Header: 'Message',
                                accessor: function (e) { return e; },
                                Cell: function (props) {
                                    var _a;
                                    return React.createElement(React.Fragment, null,
                                        React.createElement(Form.Field, null,
                                            React.createElement(Form.TextArea, { className: "message-field", value: props.value.msg, disabled: true })),
                                        React.createElement("br", null),
                                        React.createElement("br", null),
                                        ((_a = _this.state.orderResponse) === null || _a === void 0 ? void 0 : _a.principalUserId) === props.value.user.id &&
                                            React.createElement(React.Fragment, null,
                                                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'edit', labelPosition: "left", label: "Edit Comment" }), onClose: _this.loadOrder },
                                                    React.createElement(Modal.Header, null, "Edit Comment"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(EditOrderCommentModal, { orderId: _this.state.orderResponse.order.id, eventId: props.value.id, onSubmit: _this.loadOrder, initialComment: props.value.msg }))),
                                                " ",
                                                React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'archive', labelPosition: "left", label: "Archive Comment" }), onClose: _this.loadOrder },
                                                    React.createElement(Modal.Header, null, "Archive Comment"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(Message, { content: "Are you sure you want to archive this comment? Archiving a comment cannot be undone, however you can still view it at the bottom of the page in the order events table.", warning: true }),
                                                        React.createElement(ArchiveOrderCommentModal, { orderId: _this.state.orderResponse.order.id, eventId: props.value.id, onSubmit: _this.loadOrder })))));
                                }
                            },
                            {
                                id: 'viewAttachments',
                                Header: 'Comment Attachments',
                                accessor: function (e) { return e; },
                                Cell: function (props) {
                                    var _a;
                                    return React.createElement(React.Fragment, null,
                                        props.value.attachments.map(function (a, index) {
                                            return React.createElement("div", { key: index },
                                                React.createElement("a", { target: "_blank", href: API_SVC_BASE_URL + ("/admin/orders/id/" + encodeURIComponent(_this.state.orderResponse.order.id) + "/events/id/" + encodeURIComponent(props.value.id) + "/attachments/id/" + a.id) },
                                                    "#",
                                                    index + 1,
                                                    " - ",
                                                    a.fileName,
                                                    " - ",
                                                    displayLocalTimestamp(a.attachment.createdAt)));
                                        }),
                                        React.createElement("br", null),
                                        ((_a = _this.state.orderResponse) === null || _a === void 0 ? void 0 : _a.principalUserId) === props.value.user.id &&
                                            React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { label: 'Upload Attachments', icon: 'upload' }), onClose: _this.loadOrder },
                                                React.createElement(Modal.Header, null, "Upload Attachments"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(UploadCommentAttachmentsModal, { orderId: _this.state.orderResponse.order.id, eventId: props.value.id, onSubmit: _this.loadOrder }))));
                                }
                            },
                            {
                                id: 'createdAt',
                                Header: 'Created',
                                accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                            }
                        ], data: this.state.orderResponse.order.events
                            .filter(function (e) { return e.type === "CREATE_COMMENT" && !e.archived; }), defaultPageSize: 50, defaultSorted: [{
                                id: 'createdAt'
                            }], minRows: 1 }),
                    React.createElement(Header, null, "Kits"),
                    this.reorder(this.state.orderResponse.order),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'mail', label: 'Email current kit versions to customer', labelPosition: 'left' }), onClose: this.loadOrder },
                            React.createElement(Modal.Header, null, "Send current kits to customer"),
                            React.createElement(Modal.Content, null,
                                React.createElement(Modal.Description, null, "Includes the current state of every kit, except for any whose current version is deleted, which will be ignored."),
                                React.createElement(EmailCurrentVersionModal, { orderId: this.state.orderResponse.order.id })))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'dollar sign', label: 'Create QuickBooks invoice', labelPosition: 'left' }), onClose: this.loadOrder },
                            React.createElement(Modal.Header, null, "Create QuickBooks Invoice"),
                            React.createElement(Modal.Content, null,
                                React.createElement(Modal.Description, null, "This should only be done when the order is complete."),
                                React.createElement(CreateInvoiceModal, { orderId: this.state.orderResponse.order.id })))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'dollar sign', label: 'Create QuickBooks Estimate', labelPosition: 'left' }), onClose: this.loadOrder },
                            React.createElement(Modal.Header, null, "Create QuickBooks Estimate"),
                            React.createElement(Modal.Content, null,
                                React.createElement(CreateEstimateModal, { orderId: this.state.orderResponse.order.id })))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement("a", { href: API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(this.state.orderResponse.order.id) + "/probe-design-csv" },
                            React.createElement(Button, { icon: 'download', label: 'Download probe design csv', labelPosition: 'left' }))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement("a", { href: API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(this.state.orderResponse.order.id) + "/probe-set-csv" },
                            React.createElement(Button, { icon: 'download', label: 'Download probe csv', labelPosition: 'left' }))),
                    React.createElement("div", { style: { 'marginTop': '1rem' } },
                        React.createElement("a", { href: API_SVC_BASE_URL + "/admin/orders/id/" + encodeURIComponent(this.state.orderResponse.order.id) + "/cish-probe-set-csv" },
                            React.createElement(Button, { icon: 'download', label: 'Download rna-cish probe csv', labelPosition: 'left' }))),
                    React.createElement("div", { style: { marginTop: '1rem' } },
                        React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'print', label: 'Prepare labels', labelPosition: 'left' }), onClose: this.loadOrder },
                            React.createElement(Modal.Header, null, "Labels"),
                            React.createElement(Modal.Content, null,
                                React.createElement(Modal.Description, null,
                                    React.createElement("p", null, "Includes the current state of every kit, except for any whose current version is deleted, which will be ignored."),
                                    React.createElement("p", null, "The text is intended to be copied elsewhere for printing.")),
                                React.createElement(LabelsModal, { order: this.state.orderResponse.order })))),
                    React.createElement("div", { style: { marginTop: '1rem' } },
                        !this.state.orderResponse.order.items.every(function (oi) {
                            return oi.versions
                                .every(function (v) { return v instanceof ExistingVersion
                                && (v.pricedKit instanceof RnaFishPricedKit || v.pricedKit instanceof SecondaryIfPricedKit); });
                        }) &&
                            React.createElement(React.Fragment, null,
                                React.createElement(Button, { onClick: this.condensedKitViewToggle, icon: this.state.condensedKitView ? 'eye slash' : 'eye', label: this.state.condensedKitView ? 'Collapse RNA-ISH Kit View' : 'Expand RNA-ISH Kit View', labelPosition: 'left' })),
                        React.createElement("br", null),
                        React.createElement(Dropdown, { placeholder: 'Add Kit', disabled: this.orderItemsNotEditable(), selection: true, search: true, options: this.getKitOptions(), onChange: this.handleKitModalChange, value: this.state.selectedKitOption, style: { marginTop: '1rem', minWidth: '400px' }, clearable: true }),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'legacy-rna-fish', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 RNA-FISH (v3.0)"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id), render: this.renderAddLegacyRnaFishKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'rna-fish', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Gold RNA-FISH"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id, 'RnaFish'), render: this.renderAddRnaFishKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'ihc2', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Gold 2\u00BAIF"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id), render: this.renderAddSecondaryIfKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'legacy-ihc2', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 2\u00BAIF"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id), render: this.renderAddLegacySecondaryIfKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'manual-gold-if', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Gold IF"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id), render: this.renderAddManualGoldIfKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'rna-cish', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Pro RNA-ISH"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id, 'RnaCish'), render: this.renderAddRnaCishKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'manual-pro', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Pro RNA-ISH"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id, 'RnaFish'), render: this.renderAddManualProKitModal }))),
                        React.createElement(Modal, { open: this.state.activeKitModalType === 'automated-gold-if', closeIcon: true, onClose: this.closeKitModal },
                            React.createElement(Modal.Header, null, "Add kit - HCR\u2122 Gold IF"),
                            React.createElement(Modal.Content, null,
                                React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Orders, this.state.orderResponse.order.id), render: this.renderAddAutomatedGoldIfKitModal })))),
                    ((_a = this.state.quantityWarnings) !== null && _a !== void 0 ? _a : []).map(function (warning, i) {
                        return React.createElement(Message, { key: i, warning: true, content: warning, onDismiss: function () { return _this.setState({ quantityWarnings: undefined }); } });
                    }),
                    this.renderOrderItems(this.state.orderResponse.order),
                    this.renderLineItems(this.state.orderResponse.order),
                    React.createElement(Header, null,
                        "Fulfillment units ",
                        React.createElement(Help, null, "The components of a kit can be shipped independently, so they are tracked separately here. Uses the latest version of each kit.")),
                    React.createElement(Table, { striped: true, celled: true },
                        React.createElement(Table.Header, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.HeaderCell, null, "Kit"),
                                React.createElement(Table.HeaderCell, null, "Component"),
                                React.createElement(Table.HeaderCell, null, "Shipments"),
                                React.createElement(Table.HeaderCell, null, "Complete"))),
                        React.createElement(Table.Body, null, visitUnitsWithCorrespondingKitComponents(this.state.orderResponse.order, function (order, lastVersion, unit, itemIndex) {
                            return React.createElement(Table.Row, { title: "Item id: " + unit.itemId, key: itemIndex + "-" + unit.componentType },
                                React.createElement(Table.Cell, null,
                                    "Kit #",
                                    itemIndex + 1,
                                    " ",
                                    React.createElement(KitDisplayModal, { admin: _this.state.condensedKitView, itemIndex: itemIndex, pricedKit: lastVersion.pricedKit, trigger: React.createElement(Button, { label: 'View', labelPosition: 'left', icon: 'eye', size: 'mini' }) })),
                                React.createElement(Table.Cell, null, unit.componentType),
                                React.createElement(Table.Cell, null, shipmentsForUnit(order, unit).length),
                                React.createElement(Table.Cell, null, unitIsComplete(order, unit) ?
                                    React.createElement(Icon, { name: 'check' }) : ''));
                        }))),
                    React.createElement(Header, null, "Events"),
                    React.createElement(ReactTable, { columns: [
                            {
                                id: 'name',
                                Header: 'User',
                                accessor: function (e) { return e.user.name; }
                            },
                            {
                                id: 'type',
                                Header: 'Type',
                                accessor: function (e) { return e; },
                                Cell: function (props) { return React.createElement("span", { title: props.value.type },
                                    props.value.type,
                                    " ",
                                    props.value.archived ? "[Archived]" : ""); }
                            },
                            {
                                id: 'pmtStatus',
                                Header: 'Payment Status',
                                accessor: function (e) { return e.pmtStatus; }
                            },
                            {
                                id: 'prodStatus',
                                Header: 'Production Status',
                                accessor: function (e) { return e.prodStatus; }
                            },
                            {
                                id: 'msg',
                                Header: 'Message',
                                accessor: function (e) { return e.msg; },
                                Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                            },
                            {
                                id: 'createdAt',
                                Header: 'Created',
                                accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                            },
                        ], data: this.state.orderResponse.order.events, defaultPageSize: 50, defaultSorted: [{
                                id: 'createdAt'
                            }], minRows: 1 }),
                    React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'comment', label: 'Add comment', labelPosition: 'left' }), onClose: this.loadOrder },
                        React.createElement(Modal.Header, null, "Add comment"),
                        React.createElement(Modal.Content, null,
                            React.createElement(AddCommentModal, { orderId: this.state.orderResponse.order.id, onSubmit: this.loadOrder })))));
    };
    SingleOrderPage.prototype.componentDidMount = function () {
        this.loadOrder();
    };
    SingleOrderPage.prototype.orderItemsNotEditable = function () {
        var notEditableStatuses = ['READY_TO_CHECK', 'READY_TO_SHIP', 'COMPLETE'];
        return notEditableStatuses.includes(this.state.orderResponse ? this.state.orderResponse.order.prodStatus : '');
    };
    return SingleOrderPage;
}(React.PureComponent));
export default SingleOrderPage;
var DeletedVersion = /** @class */ (function () {
    function DeletedVersion() {
    }
    return DeletedVersion;
}());
var ExistingVersion = /** @class */ (function () {
    function ExistingVersion(pricedKit) {
        this.pricedKit = pricedKit;
    }
    return ExistingVersion;
}());
export { ExistingVersion };
export var KitComponentType;
(function (KitComponentType) {
    KitComponentType["V3RnaFishProbeSet"] = "V3_RNA_FISH_PROBE_SET";
    KitComponentType["V3RnaFishAmplifier"] = "V3_RNA_FISH_AMPLIFIER";
    KitComponentType["V3RnaFishBuffers"] = "V3_RNA_FISH_BUFFERS";
    KitComponentType["GoldRnaFishProbeSet"] = "GOLD_RNA_FISH_PROBE_SET";
    KitComponentType["GoldManualAmplifier"] = "GOLD_RNA_FISH_AMPLIFIER";
    KitComponentType["GoldRnaFishBuffers"] = "GOLD_RNA_FISH_BUFFERS";
    KitComponentType["SecondaryIfProbe"] = "V3_SECONDARY_IF_PROBE";
    KitComponentType["SecondaryIfAmplifier"] = "V3_SECONDARY_IF_AMPLIFIER";
    KitComponentType["SecondaryIfBuffers"] = "V3_SECONDARY_IF_BUFFERS";
    KitComponentType["GoldSecondaryIfProbe"] = "GOLD_SECONDARY_IF_PROBE";
    KitComponentType["GoldSecondaryIfAmplifier"] = "GOLD_SECONDARY_IF_AMPLIFIER";
    KitComponentType["GoldSecondaryIfBuffers"] = "GOLD_SECONDARY_IF_BUFFERS";
    KitComponentType["AutomatedProProbeSet"] = "AUTOMATED_PRO_PROBE_SET";
    KitComponentType["AutomatedProDetect"] = "AUTOMATED_PRO_DETECT";
    KitComponentType["AutomatedProChromogen"] = "AUTOMATED_PRO_CHROMOGEN";
    KitComponentType["AutomatedProMisc"] = "AUTOMATED_PRO_MISC";
    KitComponentType["ManualProProbeSet"] = "MANUAL_PRO_PROBE_SET";
    KitComponentType["ManualProDetect"] = "MANUAL_PRO_DETECT";
    KitComponentType["ManualProBuffers"] = "MANUAL_PRO_BUFFERS";
    KitComponentType["ManualProChromogen"] = "MANUAL_PRO_CHROMOGEN";
    KitComponentType["ManualGoldIfEncoder"] = "MANUAL_GOLD_IF_ENCODER";
    KitComponentType["ManualGoldIfAmplifier"] = "MANUAL_GOLD_IF_AMPLIFIER";
    KitComponentType["ManualGoldIfBuffers"] = "MANUAL_GOLD_IF_BUFFERS";
    KitComponentType["AutomatedGoldIfEncoder"] = "AUTOMATED_GOLD_IF_ENCODER";
    KitComponentType["AutomatedGoldIfDetect"] = "AUTOMATED_GOLD_IF_DETECT";
})(KitComponentType || (KitComponentType = {}));
// Don't modify at runtime; treat as an immutable list to avoid unleashing zalgo!
export var allKitComponentTypes = [
    KitComponentType.V3RnaFishProbeSet,
    KitComponentType.V3RnaFishAmplifier,
    KitComponentType.V3RnaFishBuffers,
    KitComponentType.GoldRnaFishProbeSet,
    KitComponentType.GoldManualAmplifier,
    KitComponentType.GoldRnaFishBuffers,
    KitComponentType.SecondaryIfProbe,
    KitComponentType.SecondaryIfAmplifier,
    KitComponentType.SecondaryIfBuffers,
    KitComponentType.GoldSecondaryIfProbe,
    KitComponentType.GoldSecondaryIfAmplifier,
    KitComponentType.GoldSecondaryIfBuffers,
    KitComponentType.AutomatedProProbeSet,
    KitComponentType.AutomatedProDetect,
    KitComponentType.AutomatedProChromogen,
    KitComponentType.AutomatedProMisc,
    KitComponentType.ManualProProbeSet,
    KitComponentType.ManualProDetect,
    KitComponentType.ManualProBuffers,
    KitComponentType.ManualProChromogen,
    KitComponentType.ManualGoldIfEncoder,
    KitComponentType.ManualGoldIfAmplifier,
    KitComponentType.ManualGoldIfBuffers,
    KitComponentType.AutomatedGoldIfEncoder,
    KitComponentType.AutomatedGoldIfDetect
];
var FulfillmentUnit = /** @class */ (function () {
    function FulfillmentUnit(itemId, componentType) {
        this.itemId = itemId;
        this.componentType = componentType;
    }
    /**
     * @param serialized The serialized form returned by serialize().
     */
    FulfillmentUnit.deserialize = function (serialized) {
        var deser = JSON.parse(serialized);
        var componentType = allKitComponentTypes.find(function (t) { return t === deser[1]; });
        if (componentType === undefined) {
            throw new Error("Unknown component type: " + deser[1]);
        }
        return new FulfillmentUnit(deser[0], componentType);
    };
    /**
     * A consistent serialized form of the unit's data.
     */
    FulfillmentUnit.prototype.serialize = function () {
        // JSON array to ensure predictable order
        return JSON.stringify([this.itemId, this.componentType]);
    };
    FulfillmentUnit.prototype.equals = function (other) {
        return this.itemId === other.itemId && this.componentType === other.componentType;
    };
    return FulfillmentUnit;
}());
export { FulfillmentUnit };
var KitDisplayModal = /** @class */ (function (_super) {
    __extends(KitDisplayModal, _super);
    function KitDisplayModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KitDisplayModal.prototype.render = function () {
        return React.createElement(Modal, { closeIcon: true, content: React.createElement("div", { style: { 'padding': '2rem' } },
                React.createElement(KitIndexHeader, { itemIndex: this.props.itemIndex, kit: this.props.pricedKit.kit, adminView: true }),
                React.createElement(KitDisplay, { pricedKit: this.props.pricedKit, displayBlastLink: false, admin: this.props.admin, quantity: this.props.quantity })), trigger: this.props.trigger, on: 'click', size: 'small' });
    };
    return KitDisplayModal;
}(React.PureComponent));
export { KitDisplayModal };
var EditShippingEstimateModal = /** @class */ (function (_super) {
    __extends(EditShippingEstimateModal, _super);
    function EditShippingEstimateModal(props) {
        var _this = _super.call(this, props) || this;
        _this.getShippingEstimate = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipping-estimate")
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            shippingCostEstimate: resp.shippingCostEstimate / 100
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't get estimate: " + rej);
                });
            });
        };
        _this.onSave = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipping-and-handling-cost", {
                shippingCostEstimate: _this.state.shippingCostEstimate ? _this.state.shippingCostEstimate * 100 : _this.state.shippingCostEstimate,
                chargeHandlingAndDryIce: _this.state.chargeHandlingAndDryIce
            });
        };
        _this.updateShippingEstimate = function (_, data) {
            _this.setState({
                shippingCostEstimate: parseInt(data.value, undefined)
            });
        };
        _this.onChargeHandlingAndDryIceChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    chargeHandlingAndDryIce: !oldState.chargeHandlingAndDryIce
                };
            });
        };
        _this.state = {
            shippingCostEstimate: _this.props.order.shippingCostEstimate ? _this.props.order.shippingCostEstimate / 100 : _this.props.order.shippingCostEstimate,
            chargeHandlingAndDryIce: _this.props.order.handlingAndDryIce > 0,
            loading: false,
            error: false
        };
        return _this;
    }
    EditShippingEstimateModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, null,
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: "/shippingCostEstimate", labelContent: "Shipping Cost Estimate" },
                    React.createElement(Input, { onChange: this.updateShippingEstimate, value: this.state.shippingCostEstimate, fluid: true, type: 'number', placeholder: '0' })),
                React.createElement(Checkbox, { checked: this.state.chargeHandlingAndDryIce, label: "Charge handling and dry ice", onChange: this.onChargeHandlingAndDryIceChange }),
                React.createElement("div", null,
                    React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.onSave, positive: true }),
                    React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'dollar sign', label: 'Get Shipping Estimate', labelPosition: 'left', onClick: this.getShippingEstimate }))));
    };
    return EditShippingEstimateModal;
}(React.PureComponent));
var ReorderModal = /** @class */ (function (_super) {
    __extends(ReorderModal, _super);
    function ReorderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onConfirm = function () {
            var adminNote = _this.state.message;
            var serializedKits = _this.props.order.items.filter(function (i) { return i.versions.slice().reverse()[0] instanceof ExistingVersion; })
                .map(function (item, index) {
                var reversedVersions = item.versions.slice().reverse();
                var lastVersion = reversedVersions[0];
                var kit = lastVersion.pricedKit.kit;
                var kitFormState;
                var serializedKit;
                /**
                 * If the probeDesignOrganism could not be found in the catalog, which should not happen, the probeSet is disabled
                 * and a comment is added to the kit.
                 */
                if (kit instanceof RnaFishKit) {
                    kitFormState = rnaFishKitToFormState(_this.props.catalog.rnaCatalog, kit, true);
                    var organismUndefined = (kitFormState.probeSetState.organism.name === "");
                    var defaulted = organismUndefined && kitFormState.probeSetEnabled;
                    kitFormState = __assign(__assign({}, kitFormState), { probeSetEnabled: (!organismUndefined), comment: _this.addReorderComment(kitFormState.comment, index) });
                    if (defaulted) {
                        adminNote = _this.editAdminNote(adminNote, index);
                    }
                    serializedKit = EditKitForm.serializeRnaFishKit(kitFormState);
                }
                else if (kit instanceof SecondaryIfKit) {
                    kitFormState = secondaryIfKitToFormState(_this.props.catalog.secondaryIfCatalog, kit, true);
                    kitFormState = __assign(__assign({}, kitFormState), { comment: _this.addReorderComment(kitFormState.comment, index) });
                    serializedKit = serializeSecondaryIfKit(kitFormState);
                }
                else if (kit instanceof ManualGoldIfKit) {
                    kitFormState = encoderKitToFormState(_this.props.catalog.secondaryIfCatalog, kit, true);
                    kitFormState = __assign(__assign({}, kitFormState), { comment: _this.addReorderComment(kitFormState.comment, index) });
                    serializedKit = serializeManualGoldIfKit(kitFormState);
                }
                /**
                 * If the probeDesignOrganism could not be found in the catalog, which should not happen, the probeSet is disabled
                 * and a comment is added to the kit.
                 */
                else if (kit instanceof AutomatedProKit) {
                    kitFormState = rnaCishKitToAdminFormState(_this.props.catalog.rnaCatalog, kit);
                    var organismUndefined = !(kitFormState.probeSetState.every(function (pss) {
                        return pss.state.organism.name !== "";
                    }));
                    var defaulted = organismUndefined && kitFormState.probeSetEnabled;
                    kitFormState = __assign(__assign({}, kitFormState), { probeSetEnabled: (!organismUndefined), comment: _this.addReorderComment(kitFormState.comment, index) });
                    if (defaulted) {
                        adminNote = _this.editAdminNote(adminNote, index);
                    }
                    serializedKit = AdminEditKitForm.serializeAutomatedProKit(kitFormState);
                }
                else if (kit instanceof AutomatedGoldIfKit) {
                    kitFormState = automatedIfKitToFormState(_this.props.catalog.secondaryIfCatalog, kit);
                    kitFormState = __assign(__assign({}, kitFormState), { comment: _this.addReorderComment(kitFormState.comment, index) });
                    serializedKit = serializeAutomatedIfKit(kitFormState, _this.props.catalog.secondaryIfCatalog);
                }
                else {
                    kitFormState = manualProKitToAdminFormState(_this.props.catalog.rnaCatalog, kit);
                    var organismUndefined = (kitFormState.probeSetState.organism.name === "");
                    var defaulted = organismUndefined && kitFormState.probeSetEnabled;
                    kitFormState = __assign(__assign({}, kitFormState), { probeSetEnabled: (!organismUndefined), comment: _this.addReorderComment(kitFormState.comment, index) });
                    if (defaulted) {
                        adminNote = _this.editAdminNote(adminNote, index);
                    }
                    serializedKit = ManualProAdminKitForm.serializeManualProAdminKit(kitFormState);
                }
                return serializedKit === undefined ? undefined : {
                    kit: serializedKit,
                    quantity: item.quantity
                };
            });
            /**
             * Filter out the kits that are deleted
             */
            serializedKits = serializedKits.filter(function (v) { return v !== undefined; });
            adminNote === _this.state.message ?
                _this.setState({
                    message: "None of the kits were defaulted\n"
                }) :
                _this.setState({
                    message: adminNote
                });
            _this.props.postRequestWithJsonResponse("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/reorder", {
                kits: serializedKits
            }, function (resp) {
                _this.setState({
                    newOrderId: resp.orderId
                });
            });
        };
        /**
         * This function adds the reorder message to the kits
         */
        _this.addReorderComment = function (comment, index) {
            var commentPrefix = "Reordered from order " + _this.props.order.id + " kit #" + (index + 1) + ".";
            return comment.length === 0 ? commentPrefix : commentPrefix + "\nOriginal comment:\n\n" + comment;
        };
        /**
         * This function notifies the admin in the modal for any kit changes
         */
        _this.editAdminNote = function (adminNote, index) {
            return adminNote === _this.state.message
                ? "Kit #" + (index + 1) + "'s probe variant has been disabled in our catalog so the probe has been disabled in the new order\n"
                : adminNote + ("Kit #" + (index + 1) + "'s probe variant has been disabled in our catalog so the probe has been disabled in the new order.\n");
        };
        _this.state = {
            message: "Note: If there are any defaulted kits you will be notified here once you confirm the reorder\n\n",
            newOrderId: ''
        };
        return _this;
    }
    ReorderModal.prototype.render = function () {
        var path = "/admin/orders/id/" + this.state.newOrderId;
        return React.createElement(React.Fragment, null,
            React.createElement("p", { style: { fontWeight: 'bold', whiteSpace: "pre-line" } }, this.state.message),
            this.state.newOrderId.length > 0 &&
                React.createElement("div", null,
                    "New Order: ",
                    React.createElement("a", { href: path, target: "_blank" }, this.state.newOrderId)),
            React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'cart', label: 'Confirm', labelPosition: 'left', onClick: this.onConfirm, positive: true }));
    };
    return ReorderModal;
}(React.PureComponent));
/**
 * Invoke callback on each fulfillment unit that maps to a currently existing component in the order.
 *
 * Returns the collected output of the callbacks.
 */
export function visitUnitsWithCorrespondingKitComponents(order, callback) {
    var perItem = order.items.map(function (item, itemIndex) {
        var lastVersion = item.versions[item.versions.length - 1];
        if (lastVersion instanceof DeletedVersion) {
            return [];
        }
        // Fulfillment units are synthetic representations of the possibility for an item to have a particular kit
        // component type, so we can generate all possible units for any item.
        return allKitComponentTypes
            .filter(function (componentType) { return kitComponentExistsInKit(componentType, lastVersion.pricedKit); })
            .map(function (componentType) {
            return callback(order, lastVersion, new FulfillmentUnit(item.id, componentType), itemIndex);
        });
    });
    // flatten... no flatMap in js :(
    return Array.prototype.concat.apply([], perItem);
}
var kitComponentExistsInKit = function (componentType, pricedKit) {
    if (pricedKit instanceof RnaFishPricedKit && pricedKit.kit.legacy) {
        switch (componentType) {
            case KitComponentType.V3RnaFishProbeSet:
                return pricedKit.kit.probeSetComponent !== undefined;
            case KitComponentType.V3RnaFishAmplifier:
                return pricedKit.kit.amplifierComponent !== undefined;
            case KitComponentType.V3RnaFishBuffers:
                return pricedKit.kit.buffersComponent !== undefined;
        }
    }
    else if (pricedKit instanceof RnaFishPricedKit && !pricedKit.kit.legacy) {
        switch (componentType) {
            case KitComponentType.GoldRnaFishProbeSet:
                return pricedKit.kit.probeSetComponent !== undefined;
            case KitComponentType.GoldManualAmplifier:
                return pricedKit.kit.amplifierComponent !== undefined;
            case KitComponentType.GoldRnaFishBuffers:
                return pricedKit.kit.buffersComponent !== undefined;
        }
    }
    else if (pricedKit instanceof SecondaryIfPricedKit && pricedKit.kit.legacy) {
        switch (componentType) {
            case KitComponentType.SecondaryIfProbe:
                return pricedKit.kit.probeComponent !== undefined;
            case KitComponentType.SecondaryIfAmplifier:
                return pricedKit.kit.amplifierComponent !== undefined;
            case KitComponentType.SecondaryIfBuffers:
                return pricedKit.kit.buffersComponent !== undefined;
        }
    }
    else if (pricedKit instanceof ManualGoldIfPricedKit) {
        switch (componentType) {
            case KitComponentType.ManualGoldIfEncoder:
                return pricedKit.kit.encoderComponent !== undefined;
            case KitComponentType.ManualGoldIfAmplifier:
                return pricedKit.kit.amplifierComponent !== undefined;
            case KitComponentType.ManualGoldIfBuffers:
                return pricedKit.kit.buffersComponent !== undefined;
        }
    }
    else if (pricedKit instanceof SecondaryIfPricedKit && !pricedKit.kit.legacy) {
        switch (componentType) {
            case KitComponentType.GoldSecondaryIfProbe:
                return pricedKit.kit.probeComponent !== undefined;
            case KitComponentType.GoldSecondaryIfAmplifier:
                return pricedKit.kit.amplifierComponent !== undefined;
            case KitComponentType.GoldSecondaryIfBuffers:
                return pricedKit.kit.buffersComponent !== undefined;
        }
    }
    else if (pricedKit instanceof AutomatedProPricedKit) {
        switch (componentType) {
            case KitComponentType.AutomatedProProbeSet:
                return pricedKit.kit.probeSetComponent.length > 0;
            case KitComponentType.AutomatedProDetect:
                return pricedKit.kit.detectComponent !== undefined;
            case KitComponentType.AutomatedProChromogen:
                return pricedKit.kit.chromogenComponent !== undefined;
            case KitComponentType.AutomatedProMisc:
                return pricedKit.kit.miscComponent !== undefined;
        }
    }
    else if (pricedKit instanceof PricedManualProKit) {
        switch (componentType) {
            case KitComponentType.ManualProProbeSet:
                return pricedKit.kit.probeSet !== undefined;
            case KitComponentType.ManualProDetect:
                return pricedKit.kit.detect !== undefined;
            case KitComponentType.ManualProChromogen:
                return pricedKit.kit.chromogen !== undefined;
            case KitComponentType.ManualProBuffers:
                return pricedKit.kit.buffers !== undefined;
        }
    }
    else if (pricedKit instanceof AutomatedGoldIfPricedKit) {
        switch (componentType) {
            case KitComponentType.AutomatedGoldIfEncoder:
                return pricedKit.kit.encoderComponent !== undefined;
            case KitComponentType.AutomatedGoldIfDetect:
                return pricedKit.kit.detectComponent !== undefined;
        }
    }
    return false;
};
export var unitIsComplete = function (order, unit) {
    return order.shipments
        .filter(function (s) {
        // filter for shipments with contents that complete this
        return s.contents
            .filter(function (c) {
            return c.fulfillmentUnit.equals(unit)
                && c.completesUnit;
        }).length > 0;
    })
        .length > 0;
};
export var shipmentsForUnit = function (order, unit) {
    return order.shipments
        .filter(function (s) {
        return s.contents
            .filter(function (c) { return c.fulfillmentUnit.equals(unit); }).length > 0;
    });
};
export var linkifyTracking = function (tracking) {
    if (!tracking) {
        return tracking;
    }
    var trackingTrimmed = tracking.trim();
    if (trackingTrimmed.length === 10) {
        return React.createElement("a", { href: "https://www.dhl.com/global-en/home/tracking/tracking-ecommerce.html?tracking-id=" + encodeURIComponent(trackingTrimmed) }, trackingTrimmed);
    }
    else {
        return React.createElement("a", { href: "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=" + encodeURIComponent(trackingTrimmed) }, trackingTrimmed);
    }
};
var labelWidth = 4;
var valueWidth = 12;
//# sourceMappingURL=SingleOrderPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SingleOrderPage.js
// module id = 331
// module chunks = 0